import React from "react";

/**
 * Wavy SVG divider. Use `flip` to orient the wave the other way.
 * `fromColor` is the top section color, `toColor` is the target section color.
 */
export const WavyDivider = ({ fromColor = "#FFFFFF", toColor = "#EEF0FB", flip = false, className = "" }) => (
  <div className={`w-full leading-none ${className}`} aria-hidden="true" style={{ backgroundColor: fromColor }}>
    <svg
      viewBox="0 0 1440 80"
      preserveAspectRatio="none"
      className={`block w-full h-[60px] md:h-[80px] ${flip ? "rotate-180" : ""}`}
    >
      <path
        d="M0,40 C240,80 480,0 720,30 C960,60 1200,80 1440,30 L1440,80 L0,80 Z"
        fill={toColor}
      />
    </svg>
  </div>
);
